import React from 'react';
import { DataTableColumn } from '../../../types/grid';
import { OperatorDef, getColumnName } from './types';
import { Button } from '../../ui/Button';

interface FilterSearchOperatorMenuProps<T extends Record<string, any>> {
  pendingColumn: DataTableColumn<T>;
  matchingOperators: OperatorDef[];
  highlightedIndex: number;
  onSelectOperator: (opDef: OperatorDef) => void;
  onBackToColumnStage: () => void;
  onHoverIndex: (idx: number) => void;
}

export function FilterSearchOperatorMenu<T extends Record<string, any>>({
  pendingColumn,
  matchingOperators,
  highlightedIndex,
  onSelectOperator,
  onBackToColumnStage,
  onHoverIndex,
}: FilterSearchOperatorMenuProps<T>) {
  return (
    <div>
      <div className="px-2.5 py-1 text-xs font-semibold text-cf-textMuted uppercase tracking-wider flex items-center justify-between border-b border-cf-border pb-1 mb-1">
        <span>{getColumnName(pendingColumn)}</span>
        <Button
          type="button"
          variant="link"
          size="xs"
          onClick={onBackToColumnStage}
          className="text-cf-accent normal-case font-normal p-0 h-auto"
        >
          Back
        </Button>
      </div>
      <div className="max-h-56 overflow-y-auto space-y-0.5 py-0.5">
        {matchingOperators.map((opDef, idx) => {
          const isSelected = highlightedIndex === idx;
          return (
            <Button
              key={opDef.op + (opDef.value || '')}
              type="button"
              variant="ghost"
              size="sm"
              onClick={() => onSelectOperator(opDef)}
              onMouseEnter={() => onHoverIndex(idx)}
              className={`w-full flex items-center justify-between px-3 py-1.5 rounded text-left text-xs transition-colors ${
                isSelected
                  ? 'bg-zinc-100 dark:bg-zinc-700/80 ring-1 ring-blue-500/50 text-cf-textPrimary font-medium'
                  : 'text-cf-textSecondary hover:bg-cf-surfaceHover hover:text-cf-textPrimary'
              }`}
            >
              <span className="font-mono font-bold text-cf-textPrimary whitespace-nowrap text-left shrink-0">
                {opDef.symbol}
              </span>
              <span className="text-cf-textMuted text-right whitespace-nowrap ml-3 text-xs truncate">
                {opDef.label}
              </span>
            </Button>
          );
        })}
      </div>
    </div>
  );
}
